import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { Divider } from '../../Divider';
export const Placeholder = ({ style, fluid, type }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [
            styles.container,
            type === 'instant' ? styles.instantContainer : {},
            fluid ? styles.fluid : null,
            style
        ] }, type === 'regular' ? (React.createElement(React.Fragment, null,
        React.createElement(View, { style: styles.image }),
        React.createElement(View, { style: styles.main },
            React.createElement(View, { style: styles.name }),
            React.createElement(View, { style: styles.subject })),
        React.createElement(View, { style: styles.actions },
            React.createElement(View, { style: [styles.contactBtn, styles.contactBtnWithMargin] }),
            React.createElement(View, { style: styles.contactBtn })))) : (React.createElement(React.Fragment, null,
        React.createElement(View, { style: styles.subject }),
        React.createElement(View, { style: styles.message }),
        React.createElement(Divider, { type: 'horizontal', style: styles.divider }),
        React.createElement(View, { style: styles.name }),
        React.createElement(View, { style: styles.tutorWrapper },
            React.createElement(View, { style: styles.image }),
            React.createElement(View, { style: styles.joinBtn }))))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    fluid: { flex: 1 },
    container: {
        backgroundColor: color.invert2.p4,
        padding: size.G,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: size.G
    },
    instantContainer: {
        alignItems: 'flex-start'
    },
    image: {
        height: 45,
        width: 45,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4
    },
    main: {
        marginTop: size.C,
        width: 110,
        alignItems: 'center'
    },
    name: {
        width: 52,
        height: size.G,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4,
        marginVertical: size.A
    },
    subject: {
        width: 84,
        height: size.F,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4,
        marginTop: size.A + 3,
        marginBottom: 3
    },
    divider: { marginVertical: size.G },
    message: {
        width: 285,
        height: size.F * 2,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4,
        marginTop: size.A + 3,
        marginBottom: 3
    },
    actions: {
        flexDirection: 'row',
        marginTop: size.G
    },
    contactBtn: {
        width: 39,
        height: 39,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4
    },
    joinBtn: {
        width: 98,
        height: 45,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4
    },
    contactBtnWithMargin: {
        marginRight: size.C
    },
    tutorWrapper: {
        width: '100%',
        marginTop: size.C,
        flexDirection: 'row',
        justifyContent: 'space-between'
    }
}));
export default Placeholder;
//# sourceMappingURL=Placeholder.js.map